import { useState } from 'react';

export const EMPTY_CONTEXT = { programme: '', route: '', intake: '', stage: '' };
export function contextSummary(context = {}) {
  return [context.programme, context.route, context.intake && `${context.intake} entry`, context.stage].filter(Boolean).join(' · ');
}

export default function QuestionContext({ value, onChange, disabled }) {
  const [editing, setEditing] = useState(false);
  return (
    <section className="mb-4 rounded-xl border border-edge bg-surface p-4" aria-label="About your question">
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="text-xs font-medium text-ink">About your question</p>
          <p className="mt-1 text-sm text-ink-muted">{contextSummary(value) || 'Still exploring? You can ask without choosing a programme.'}</p>
        </div>
        <button type="button" disabled={disabled} aria-expanded={editing} onClick={() => setEditing((open) => !open)} className="shrink-0 text-sm text-link disabled:opacity-50">{editing ? 'Done' : 'Edit details'}</button>
      </div>
      {editing && (
        <fieldset disabled={disabled} className="mt-4">
          <p className="mb-3 text-xs text-ink-muted">Optional. Leave anything you do not know blank. Changes apply to your next question.</p>
          <div className="grid gap-3 sm:grid-cols-2">
            {[
              ['programme', 'Programme or interest', 'e.g. BA, linguistics, still exploring'],
              ['route', 'Qualification / application route', 'e.g. HKDSE / JUPAS, IB, A-level'],
              ['intake', 'Intended intake', 'e.g. 2027 or 2027/28']
            ].map(([key, label, placeholder]) => (
              <label key={key} className="block text-xs text-ink-muted">{label}
                <input value={value[key]} maxLength={120} placeholder={placeholder} onChange={(event) => onChange({ ...value, [key]: event.target.value })} className="mt-1 w-full rounded-lg border border-edge bg-canvas px-3 py-2 text-sm text-ink" />
              </label>
            ))}
            <label className="block text-xs text-ink-muted">Where are you in the process?
              <select value={value.stage} onChange={(event) => onChange({ ...value, stage: event.target.value })} className="mt-1 w-full rounded-lg border border-edge bg-canvas px-3 py-2 text-sm text-ink">
                <option value="">Not specified</option>
                <option value="Exploring">Still exploring</option>
                <option value="Applying">Preparing an application</option>
                <option value="Offer holder">I have an offer</option>
                {value.stage && !['Exploring', 'Applying', 'Offer holder'].includes(value.stage) && <option value={value.stage}>{value.stage}</option>}
              </select>
            </label>
          </div>
          <button type="button" onClick={() => onChange({ ...EMPTY_CONTEXT })} className="mt-3 text-xs text-link">Clear details</button>
        </fieldset>
      )}
    </section>
  );
}
